/**
 *  users.js
 *  Security Care
 *
 *  Last update by Bruno Bandeira on 05/03/2019.
 *  Contact: bruno@avamobile.com.br
 *
 *  Copyright © 2018 AVA Soft Solutions. All rights reserved.
 */

import * as actionTypes from './actionTypes';

export const saveUsers = value => ({
    type: actionTypes.SAVE_USERS,
    users: value
});

export const clearUsers = value => ({
    type: actionTypes.CLEAR_USERS,
    users: []
});


// WEBPACK FOOTER //
// ./src/actions/users.js